export default "__VITE_PUBLIC_ASSET__7b15b67e__"